module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/balloon02-0c5f9f7d7d47977da19e3b8e23bbf726.png";